// extracted by mini-css-extract-plugin
module.exports = {"image":"setNewPassword_image__2DpaX"};